import FunctionalWorkerService from '../../../../services/FunctionalWorkerService';
import StateSanitizeUtilsFunctionalWorker from './StateSanitizeUtils.functional.worker';
import {
  ASYNC_SANITIZE_ELEMENTS_WORKER_MSG,
  ASYNC_EXTRACT_SKIPPED_SHOTS_WORKER_MSG,
} from './constants';

export default class StateSanitizeUtilsFunctionalWorkerService extends FunctionalWorkerService {
  constructor() {
    super(StateSanitizeUtilsFunctionalWorker);
  }

  /**
   * @function sanitizeElements
   * @param  {CreativeDocumentModel} documentModel
   * @param  {ReduxState} state
   * @return {Promise} Promise which resolves with the updated state after sanitizing elements in a worker.
   */
  sanitizeElements = (documentModel, state) => {
    return this.postMessage(ASYNC_SANITIZE_ELEMENTS_WORKER_MSG, {
      state,
      documentModelJSON: documentModel.toJSON(),
    });
  };

  /**
   * @function extractSkippedShots
   * @param  {CreativeDocumentModel} documentModel
   * @return {Promise} Promise which resolves with the updated state after extracting skipped shots.
   */
  extractSkippedShots = (documentModel) => {
    return this.postMessage(ASYNC_EXTRACT_SKIPPED_SHOTS_WORKER_MSG, {
      documentModelJSON: documentModel.toJSON(),
    });
  };
}
